import Button from '@classify/react-core-components/Button';

import { translate } from '@openclassrooms/translations';

import modalize from '../modalize';

import ModalWrapper from './ModalWrapper';
import ModalActions from './ModalActions';
import ModalContent from './ModalContent';

const AlertModal = (props) => {
  const { children, onAccept } = props;

  return (
    <ModalWrapper>
      <ModalContent>{children}</ModalContent>
      <ModalActions>
        <Button onClick={onAccept} variant="primary">
          {translate('global.word.ok')}
        </Button>
      </ModalActions>
    </ModalWrapper>
  );
};

export default modalize({ contentLabel: 'Alert', className: 'modal--confirm' })(AlertModal);
